//angular
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//others
import * as auth0 from 'auth0-js';
//app
import { AppAnimations } from '../../../_shared/animations';
import { AUTH_CONFIG_DESKTOP } from '../../../../environments/environment';
import { ValidatorService } from '../../../_shared/validators/validator.service';
import { AuthService } from 'src/app/_core/services/auth.service';
import { environment } from 'src/environments/environment';
import { EnvironmentNames, HashToCreateAccount } from 'src/app/app.data';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  animations: [ AppAnimations ]
})

export class SignUpComponent implements OnInit {
  enableCreateCompanyButton: boolean = false;
  errCode: number;
  errMessage: string;
  hide: boolean = true;
  hashSecret: string = null;
  messageStatus: string = 'hidden';
  form: FormGroup;
  formSubmitted: boolean = false;

  // Configure Auth0
  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG_DESKTOP.domain,
    clientID: AUTH_CONFIG_DESKTOP.clientID,
    redirectUri: AUTH_CONFIG_DESKTOP.callbackURL,
    responseType: AUTH_CONFIG_DESKTOP.responseType,
    scope: AUTH_CONFIG_DESKTOP.scope
  });

  constructor(
    public _auth: AuthService,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private _validatorService: ValidatorService,
  ) {
    this._iconRegistry.addSvgIcon('logo-rebillia', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-01.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-07.svg'));

     this.route.params.subscribe(params => {
      this.hashSecret = params['id'];
    })
  }

  setUpForm() {
    this.form = this._fb.group({
      firstName: ['', [Validators.required, this._validatorService.emptySpace, Validators.minLength(3), Validators.maxLength(255)]],
      lastName: ['', [Validators.required, this._validatorService.emptySpace, Validators.minLength(3), Validators.maxLength(255)]],
      email: ['', [Validators.required, this._validatorService.emptySpace, this._validatorService.email]],
      password: ['', [Validators.required, this._validatorService.emptySpace]]
    });
  };

  ngOnInit() {
    this.setUpForm();
    this.enableCreateCompanyButton = (environment.name != EnvironmentNames.prod);
    if(this.hashSecret) {
      this.enableCreateCompanyButton = this.hashSecret !== HashToCreateAccount.hashUsed;
    }
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    const values = {
      firstName: this.form.get('firstName').value,
      lastName: this.form.get('lastName').value,
      email: this.form.get('email').value,
      password: this.form.get('password').value
    };

    this.signUp(values);
  }

  signUp(values) {
    this.auth0.redirect.signupAndLogin({
      connection: AUTH_CONFIG_DESKTOP.connection,
      email: values.email,
      password: values.password,
      userMetadata: {
        name: `${values.firstName} ${values.lastName}`,
        given_name: values.firstName,
        family_name: values.lastName,
      },
    }, err  => {
      if (err) {
        this.formSubmitted = !this.formSubmitted;
        this.errCode = err.statusCode;
        this.errMessage = err.policy;
        this.messageStatus = 'visible';
      }
    });
  }

}
